<template>
  <div style="height: 100%;border: 1px solid rgb(9, 79, 148);box-sizing: border-box" class="logoin">
    <div id="login-box" style="width: 39%;height: 52%;position: absolute;top:10%;left:30%;background-color: transparent;text-align: center">
      <p style="color: white;font-size: 1.92vw;font-family: 微软雅黑;">"河南省交通运输科学技术进步奖"申报系统</p>
      <div style="margin-top: 4%;">
        <el-input placeholder="请设置以字母开头的字母和数字组合" size="large" v-model="formRegister.username" class="input">
          <template slot="prepend">
            <div class="label">账号名</div>
          </template>
        </el-input>
      </div>
      <div style="margin-top: 1%;">
        <el-input type="password" placeholder="请设置登录密码" v-model="formRegister.password" class="input">
          <template slot="prepend">
            <div class="label">用户密码</div>
          </template>
        </el-input>
      </div>
      <div style="margin-top: 1%;">
        <el-input type="password" placeholder="请再次输入密码" v-model="formRegister.passwordRepeat" class="input">
          <template slot="prepend">
            <div class="label">密码确认</div>
          </template>
        </el-input>
      </div>
      <div style="margin-top: 1%;">
        <el-input placeholder="请输入单位名称" v-model="formRegister.department" class="input">
          <template slot="prepend">
            <div class="label">单位名称</div>
          </template>
        </el-input>
      </div>
      <div style="margin-top: 1%;">
        <el-input placeholder="请输入公司社会信用统一代码" v-model="formRegister.socialcode" class="input">
          <template slot="prepend">
            <div class="label">社会统一信用代码</div>
          </template>
        </el-input>
      </div>
      <div style="margin-top: 1%;">
        <el-input placeholder="请输入您的真实姓名" v-model="formRegister.name" class="input">
          <template slot="prepend">
            <div class="label">联系人</div>
          </template>
        </el-input>
      </div>
      <div style="margin-top: 1%;">
        <el-input placeholder="请输入您的联系电话" v-model="formRegister.phone" class="input">
          <template slot="prepend">
            <div class="label">联系电话</div>
          </template>
        </el-input>
      </div>
      <div style="margin-top: 1%;">
        <el-input placeholder="请输入您的联系邮箱" v-model="formRegister.email" class="input">
          <template slot="prepend">
            <div class="label">联系邮箱</div>
          </template>
        </el-input>
      </div>
      <div style="width: 100%;margin-top: 1%;">
        <el-button type="primary" @click="submitForm" class="btn_login" :disabled="isFunctionDisabled">{{ loginstatus }}</el-button>
      </div>
      <router-link to="/">已有账号？点击登录</router-link>
    </div>
  </div>
</template>

<script>
import utils from "@/views/js/utils";

export default {
  name: "register",
  data() {
    return {
      formRegister: {
        username: '',
        password: '',
        passwordRepeat: '',
        addtime: '',
        name: '',
        phone: '',
        email: '',
        socialcode: '',
        department: '',
      },
      isFunctionDisabled: false,
      loginstatus: '立即注册',
    }
  },
  methods: {
    submitForm() {
      if (this.formRegister.username == '' || this.formRegister.password == '' || this.formRegister.passwordRepeat == '' || this.formRegister.name == '' || this.formRegister.phone == ''
        || this.formRegister.email == ''|| this.formRegister.socialcode == ''|| this.formRegister.department == '') {
        this.$message.error('请填写完整信息！');
      } else if (this.formRegister.password != this.formRegister.passwordRepeat) {
        this.$message.error('两次密码输入不匹配');
      } else {
        /*登录账号发送请求*/
        this.loginstatus = '注册中';
        this.isFunctionDisabled = true;
        this.$axios({
          method: 'post',
          url: this.GLOBAL.URL + 'register/addUser',
          data: {
            username: this.formRegister.username,
            password: this.formRegister.password,
            addtime: this.dateFormatMonthYYYYMM(new Date()),
            name: this.formRegister.name,
            phone: this.formRegister.phone,
            email: this.formRegister.email,
            socialcode: this.formRegister.socialcode,
            department: this.formRegister.department,
          }
        }).then((res) => {
          let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
          if (resp.code == 1000) {
            this.showSuccessMsg(resp.message)
            this.isFunctionDisabled = false;
          } else {
            this.showFailMsg(resp.message)
            this.isFunctionDisabled = false;
            this.loginstatus = '立即注册';
            return
          }
          this.isFunctionDisabled = false;
          this.$router.push({
            path: '/'
          });
        }),
          /*定时10秒*/
          setTimeout(() => {
            if (this.isFunctionDisabled) {
              this.$message.error('注册失败，请检查网络是否正常！');
              this.isFunctionDisabled = false;
            }
            this.loginstatus = '立即注册';
          }, 10000);
      }
    }
  }
}
</script>

<style scoped>
.logoin {
  background: url("../assets/login_background.jpg");
}

.btn_login {
  width: 60%;
  background-color: #1a89ff;
  height: 5.8vh;
  border-radius: 1vw;
  font-size: 1.2vw;
  font-family: 微软雅黑;
  max-width: 450px;
}

.btn_login:hover {
  background-color: #2a71d8;
}

/deep/ .el-input__inner {
  height: 5vh;
  line-height: 6vh;
  font-size: 1.5vh;
}

a {
  color: white;
  text-decoration: none;
}

a:hover {
  color: #1a89ff;
}

.label {
  width: 120px;
  text-align: right
}
.input{
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/views/register.vue